import { render } from "./NamedButton.vue?vue&type=template&id=3ae54964&ts=true"
import script from "./NamedButton.vue?vue&type=script&lang=ts"
export * from "./NamedButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__